import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./Component/redux/store";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SocketProvider } from "../src/useSocket.js/socket";

import { ThemeProvider, createTheme } from "@mui/material/styles"; // Import MUI ThemeProvider
import CssBaseline from "@mui/material/CssBaseline"; // Optional for consistent styling

// Import Montserrat font
import "@fontsource/montserrat/100.css";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/900.css";

// Create a custom MUI theme
const theme = createTheme({
  typography: {
    fontFamily: "Montserrat, Arial, sans-serif",
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <SocketProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline /> {/* Ensures consistent styles across browsers */}
        <App />
        <ToastContainer />
      </ThemeProvider>
    </SocketProvider>
  </Provider>
);

reportWebVitals();
